export const USER_PREFERENCES_SLICE_KEY = 'userPreferences' as const;
